import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AngularMaterialModule } from 'src/app/material.module';
import { AccountsService } from "@lib/services";
import { BaseComponent } from "@lib/components";
import { MatSnackBar } from "@angular/material/snack-bar";
interface Wallet {
    currencyName: string;
    currencyCode: string;
    balance: string;
    flag: string;
    selected: boolean;
    id: string;
}
@Component({
    selector: 'app-add-wallet',
    templateUrl: './add-wallet.component.html',
    imports: [AngularMaterialModule],
    standalone: true,
    styleUrls: ['./add-wallet.component.scss'],
})
export class AddWalletComponent extends BaseComponent {
    isLoading = false;
    enableAddButton = false;
    constructor(
      private _snackbar: MatSnackBar,
      private readonly dialog: MatDialog,
      public dialogRef: MatDialogRef<AddWalletComponent>,
      @Inject(MAT_DIALOG_DATA) public data: { message: string, wallets: any },
      private readonly accountsService: AccountsService,
    ) {
      super()
    }

    wallets: Wallet[] = [
        {
            currencyName: 'Sudanese Pound',
            currencyCode: 'SDG',
            balance: '110,000 SDG',
            flag: '../../../../../assets/currency-flags/SDG-flag.svg',
            id: 'CP_FIB_SDG_NEW',
            selected: true,
        },
        {
            currencyName: 'UAE Dirham',
            currencyCode: 'AED',
            balance: '3,4022.50 AED',
            flag: '../../../../../assets/currency-flags/AED-flag.svg',
            id: 'CP_FIB_AED',
            selected: false,
        },
        {
            currencyName: 'US Dollar',
            currencyCode: 'USD',
            balance: '2,500.00 USD',
            flag: '../../../../../assets/currency-flags/USD-flag.svg',
            id: 'CP_FIB_USD',
            selected: false,
        },
        // {
        //     currencyName: 'TRY',
        //     currencyCode: 'TRY',
        //     balance: '2,500.00 USD',
        //     flag: '../../../../../assets/currency-flags/TRY-flag.svg',
        //     id: 'CP_FIB_TRY',
        //     selected: false,
        // },
        // {
        //     currencyName: 'CAD',
        //     currencyCode: 'CAD',
        //     balance: '2,500.00 USD',
        //     flag: '../../../../../assets/currency-flags/CAD-flag.svg',
        //     id: 'CP_FIB_CAD',
        //     selected: false,
        // },
        // {
        //     currencyName: 'EGP',
        //     currencyCode: 'EGP',
        //     balance: '2,500.00 USD',
        //     flag: '../../../../../assets/currency-flags/EGP-flag.svg',
        //     id: 'CP_FIB_EGP',
        //     selected: false,
        // },
        {
            currencyName: 'SAR',
            currencyCode: 'SAR',
            balance: '2,500.00 USD',
            flag: '../../../../../assets/currency-flags/SAR-flag.svg',
            id: 'CP_FIB_SAR',
            selected: false,
        },
        // {
        //     currencyName: 'OMR',
        //     currencyCode: 'OMR',
        //     balance: '2,500.00 USD',
        //     flag: '../../../../../assets/currency-flags/OMR-flag.svg',
        //     id: 'CP_FIB_OMR',
        //     selected: false,
        // },
        // {
        //     currencyName: 'KWD',
        //     currencyCode: 'KWD',
        //     balance: '2,500.00 USD',
        //     flag: '../../../../../assets/currency-flags/KWD-flag.svg',
        //     id: 'CP_FIB_KWD',
        //     selected: false,
        // },
        {
            currencyName: 'EUR',
            currencyCode: 'EUR',
            balance: '2,500.00 USD',
            flag: '../../../../../assets/currency-flags/EUR-flag.svg',
            id: 'CP_FIB_EUR',
            selected: false,
        },
        {
            currencyName: 'GBP',
            currencyCode: 'GBP',
            balance: '2,500.00 USD',
            flag: '../../../../../assets/currency-flags/GBP-flag.svg',
            id: 'CP_FIB',
            selected: false,
        },
        // {
        //     currencyName: 'QAR',
        //     currencyCode: 'QAR',
        //     balance: '2,500.00 USD',
        //     flag: '../../../../../assets/currency-flags/QAR-flag.svg',
        //     id: 'CP_FIB_QAR',
        //     selected: false,
        // },
        // {
        //     currencyName: 'BHD',
        //     currencyCode: 'BHD',
        //     balance: '2,500.00 USD',
        //     flag: '../../../../../assets/currency-flags/BHD-flag.svg',
        //     id: 'CP_FIB_BHD',
        //     selected: false,
        // }
    ];

    get filterWallets() {
      const excludedCurrencies = this.data.wallets.map((item: any) => item.currency);

      return this.wallets.filter((wallet: any) => !excludedCurrencies.includes(wallet.currencyCode));
    }

    protected handleSelectWalletItem(item: any) {
      this.wallets.forEach(wallet => wallet.selected = false);
      item.selected = true
      this.enableAddButton = true
    }

    protected handleAddWallet() {
      this.isLoading = true
      const { id = '' } = this.wallets.find(item => item.selected) || {}
      this.accountsService.accountDetails(id).subscribe({
        next: value => {
          this.isLoading = false
          this.accountsService.reloadWalletList.emit(value)
          this.dialogRef.close(value)
        },
        error: (error) => {
          this.isLoading = false
          this.createApiErrorSnackBar(this._snackbar, error);
        },
      })
    }
}
